import { AllEquipmentBackButton } from '@/components/Analysis/modules/pointOfInterest';
import { EquipmentDetails } from '@/components/Analysis/shared/EquipmentsTab/EquipmentDetails';
import { IsometricDownloadButton } from '@/components/Analysis/shared/EquipmentsTab/EquipmentDetails/IsometricDownloadButton';
import { useAtomValue } from 'jotai';
import * as state from '@/components/Analysis/state';
import useAssemblyDetails from '@/hooks/useAssemblyDetails';
import { ScrollContainer } from '../ComponentsList/styles';

export const ComponentDetails = ({
  changeTab,
}: {
  changeTab: (selectedTabIndex: number) => void;
}) => {
  const selectedSpherical = useAtomValue(state.selectedSpherical);
  const { assembly: assemblyDetails, loading: assemblyDetailsLoading } = useAssemblyDetails();
  return (
    <ScrollContainer marginBottom="4.8rem">
      <AllEquipmentBackButton
        changeTab={changeTab}
        retainAssemblyView={!!selectedSpherical}
        customLabel={'All components'}
      />
      <EquipmentDetails
        assembly={assemblyDetails}
        isLoadingAssemblyDetails={assemblyDetailsLoading}
        isUncontextualized={!!assemblyDetails?.isUncontextualized}
      />
      {assemblyDetails && !assemblyDetails?.isUncontextualized && (
        <IsometricDownloadButton assembly={assemblyDetails} />
      )}
    </ScrollContainer>
  );
};
